import type { IconNode } from '../types';

/**
 * @name cocktail
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOSA2IDYuNiAyLjhDNi4zIDIuNCA1LjYgMiA1IDJIMiIgLz4KICA8cGF0aCBkPSJtMTggNi03IDgtNy04WiIgLz4KICA8cGF0aCBkPSJNMTUuNCA5LjFBNCA0IDAgMSAwIDE0IDYiIC8+CiAgPHBhdGggZD0iTTExIDE0djgiIC8+CiAgPHBhdGggZD0iTTcgMjJoOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/cocktail
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cocktail: IconNode = [
  ['path', { d: 'M9 6 6.6 2.8C6.3 2.4 5.6 2 5 2H2', key: '13xxwc' }],
  ['path', { d: 'm18 6-7 8-7-8Z', key: '1hyb1f' }],
  ['path', { d: 'M15.4 9.1A4 4 0 1 0 14 6', key: '1yqyjb' }],
  ['path', { d: 'M11 14v8', key: 'y563rw' }],
  ['path', { d: 'M7 22h8', key: '12o9xa' }],
];

export default cocktail;
